import React, { useState } from "react";
import axios from "axios";

const useFileUpload = ({
    onFinish = ({ axiosMode, status, values }) => {},
    onBefore = ({ axiosMode, status }) => {},
}) => {
    const [data, setData] = useState([]);
    let mainApi = `/media_classification_storage/api/file/upload`;
    const getFileUploadData = (params) => {
        onBefore({
            axiosMode: "get",
        });
        return axios
            .get(mainApi, {
                responseType: "blob",
                params: params,
            })
            .then((response) => {
                let data = response.data;
                var blob_ = new Blob([data], {
                    type: "image/jpg", // this is the only MIME for SVG
                });
                const dataurl = URL.createObjectURL(blob_);

                setData(dataurl);
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error",
                    });
                }

                return {
                    dataurl,
                };
            });
    };

    const postFileUploadData = (file) => {
        onBefore({
            axiosMode: "post",
        });
        let e = file;
        let form_data = new FormData();
        form_data.append("inputFile", e);
        return axios
            .post(`/media_classification_storage/api/file/upload`, form_data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                let file_id = parseInt(response.data.file_id);
                const dataurl = URL.createObjectURL(e);
                onFinish({
                    axiosMode: "post",
                    status: "success",
                });
                return {
                    file_id,
                    dataurl,
                    file_client_name: e.name,
                    upload_time: e.lastModifiedDate.toLocaleString(),
                };
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "error",
                });
            });
    };
    // const patchFileUploadData = (data) => {
    //     onBefore({
    //         axiosMode: "patch",
    //     });
    //     axios
    //         .patch(
    //             mainApi,

    //             data
    //         )
    //         .then((response) => {
    //             let responseData = response.data;
    //             let status = responseData?.status;
    //             if (status === "fail") {
    //                 onFinish({
    //                     axiosMode: "patch",
    //                     status: "error",
    //                 });
    //             } else {
    //                 onFinish({
    //                     axiosMode: "patch",
    //                     status: "success",
    //                 });
    //             }
    //         })
    //         .catch(() => {
    //             onFinish({
    //                 axiosMode: "patch",
    //                 status: "error",
    //             });
    //         });
    // };
    const deleteFileUploadData = (data) => {
        onBefore({
            axiosMode: "delete",
        });
        axios
            .delete(mainApi, {
                data,
            })
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "fail") {
                    onFinish({
                        axiosMode: "delete",
                        status: "error",
                    });
                } else {
                    onFinish({
                        axiosMode: "delete",
                        status: "success",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "delete",
                    status: "error",
                });
            });
    };
    const base64ToFile = (base64String, fileName) => {
        // Split the base64 string to get the mime type and the data part
        const arr = base64String.split(",");
        const mimeType = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]); // Decode base64
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        // Convert the binary string to an array of bytes
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        // Create a Blob from the byte array
        const blob = new Blob([u8arr], { type: mimeType });
        // Convert the Blob to a File object
        const file = new File([blob], fileName, { type: mimeType });
        return file;
    };
    return {
        FileUploadData: data,
        getFileUploadData,
        postFileUploadData,
        deleteFileUploadData,
        base64ToFile,
    };
};
export { useFileUpload };
